import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space, width, flex, order, alignSelf } from 'styled-system';
import gridConfig from '../../themes/GridConfig';

const { gutters, vspace } = gridConfig;
const StyledColumn = styled.div(
  {
    boxSizing: 'border-box',
  },
  space,
  width,
  flex,
  order,
  alignSelf
);

function Column(props) {
  const { gutterless, children, ...other } = props;

  // px={gutters} sets the horizontal padding
  return (
    <StyledColumn
      px={gutters}
      mb={vspace}
      {...(gutterless ? { mb: gridConfig.resets, px: gridConfig.resets } : {})}
      {...other}
    >
      {children}
    </StyledColumn>
  );
}

// Redefine the propTypes from styled system
Column.propTypes = {
  gutterless: PropTypes.bool,
  ...space.propTypes,
  ...width.propTypes,
  ...flex.propTypes,
  ...order.propTypes,
  ...alignSelf.propTypes,
};

Column.defaultProps = {
  gutterless: false,
};

/* @component */
export default Column;
